import { trigger, transition, query, style, stagger, animate } from "@angular/animations";

export const slideUp = [
    trigger('slideUpAnimation', [
        transition('* <=> *', [
            query(
                ':enter',
                [
                    style({ opacity: 0, transform: 'translateY(100%) rotate3d(0, 20, 0, 25deg)' }),
                    stagger(
                        '25ms',
                        animate(
                            '300ms cubic-bezier(.85,.02,.46,.89)',
                            style({ opacity: 1, transform: 'translateY(0%) rotate3d(0, 0, 0, 0deg)' })
                        )
                    )
                ],
                { optional: true }
            )
        ])
    ])
]

export const slideDown = [
    trigger('slideDownAnimation', [
        transition('* <=> *', [
            query(
                ':enter',
                [
                    style({ opacity: 0, transform: 'translateY(-15%) rotate3d(0, 20, 0, 25deg)' }),
                    stagger(
                        '25ms',
                        animate(
                            '100ms cubic-bezier(.85,.02,.46,.89)',
                            style({ opacity: 1, transform: 'translateY(0%) rotate3d(0, 0, 0, 0deg)' })
                        )
                    )
                ],
                { optional: true }
            )
        ])
    ])
]